import { Controller, useFormContext, useWatch } from 'react-hook-form'

import { determineStateData } from 'commons/utils'
import { FF2, Select } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

import { useSubjectInformationItemContext } from '../../../SubjectInformationItemContext'

export const IdState = ({ index1, index2 }: { index1: number; index2: number }) => {
  const { control } = useFormContext<SarEdit>()
  const { isAllInfoUnavailable } = useSubjectInformationItemContext()
  const country = useWatch({ control, name: `subjectsInfo.${index1 as 0}.idsInfo.${index2 as 0}.idCountry` })
  const state = useWatch({ control, name: `subjectsInfo.${index1 as 0}.idsInfo.${index2 as 0}.idState` })
  const states = determineStateData(country)

  // disable input if it has one option and it's selected
  const isDisabled = states.length === 1 && state === states[0].value

  return (
    <Controller
      name={`subjectsInfo.${index1 as 0}.idsInfo.${index2 as 0}.idState`}
      control={control}
      render={({ field }) => (
        <FF2
          field={field}
          label="Issuing State"
          input={(props) => (
            <Select
              {...props}
              searchable
              data={states}
              emptyOption={{ label: 'Not selected', value: '' }}
              disabled={isAllInfoUnavailable || isDisabled}
            />
          )}
        />
      )}
    />
  )
}
